<template>
  <div>
    <div class="d-flex mb-3">
      <h1 class="h4 primary--text">
        {{ $t('views.consolidator_receiving_details.receiving_notice_details') }}
      </h1>
      <div class="ml-auto d-flex">
        <router-link
          to="/consolidator/asn-receiving-list"
          class="shipment-notice__back-link my-auto"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            viewBox="0 0 10 10"
          >
            <path
              d="M9,4l.881.881L6.394,8.375H14v1.25H6.394l3.487,3.494L9,14,4,9Z"
              transform="translate(-4 -4)"
            />
          </svg>
          {{ $t('views.consolidator_receiving_details.back_to_list') }}
        </router-link>
      </div>
    </div>

    <app-loader v-if="loading" />

    <div v-else>
      <main class="shipment-notice__main">
        <b-row>
          <b-col cols="6">
            <div class="mb-3">
              <div class="shipment-notice__label">
                {{ $t('views.consolidator_receiving_details.date') }}
              </div>
              <div class="shipment-notice__value">
                {{ shipment.date }}
              </div>
            </div>
            <div class="mb-3">
              <div class="shipment-notice__label">
                {{ $t('views.consolidator_receiving_details.receiving_number') }}
              </div>
              <div class="shipment-notice__value">
                {{ shipment.number }}
              </div>
            </div>
            <div class="mb-3">
              <div class="shipment-notice__label">
                {{ $t('views.consolidator_receiving_details.is_received') }}
              </div>
              <div class="shipment-notice__value">
                {{ shipment.isReceived ? $t('common.yes') : $t('common.no') }}
              </div>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="mb-3">
              <div class="shipment-notice__label">
                {{ $t('views.consolidator_receiving_details.receving_asn_number') }}
              </div>
              <div class="shipment-notice__value">
                {{ shipment.asn.number }}
              </div>
            </div>

            <div class="mb-3">
              <div class="shipment-notice__label">
                {{ $t('views.consolidator_receiving_details.receving_asn_date') }}
              </div>
              <div class="shipment-notice__value">
                {{ shipment.asn.date }}
              </div>
            </div>
          </b-col>
        </b-row>
      </main>

      <div class="d-flex mt-10 mb-3">
        <h2 class="h4 primary--text">
          {{ $t('views.shipment_notice_creation.packing') }}
        </h2>
      </div>
      <v-data-table
        :headers="packingHeaders"
        :items="shipment.packing"
        disable-pagination
        disable-sort
        hide-default-footer
      >
        <template v-slot:item.boxSerialNumberLevel1="{ item }">
          {{ item.boxSerialNumberLevel1 }}
        </template>

        <template v-slot:item.status="{ item }">
          {{ item.status }}
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AppLoader from '@/components/common/AppLoader.vue';

export default {
  name: 'ConsolidatorShippingDetails',

  components: {
    AppLoader,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      shipment: {
      },
      packingHeaders: [
        {
          text: this.$t('views.shipment_notice_creation.box_serial_number_level_1'),
          value: 'boxSerialNumberLevel1',
        },
        {
          text: 'OK/NOK',
          value: 'status',
        },
      ],
      loading: false,
    };
  },

  computed: {
    ...mapState({ supplierData: 'supplier' }),
  },

  created() {
    this.getItem();
  },

  methods: {
    async getItem() {
      this.loading = true;
      try {
        const { data = {} } = await this.$http.get(`/receiving/${this.id}`);
        this.shipment = {
          ...data,
          date: this.getDate(data.date, 'L LT'),
        };
      } catch (err) {
        this.$http.mockApiError(err);
      } finally {
        this.loading = false;
      }
    },

    getDate(date, format = 'LLL', tz) {
      if (!date) { return ''; }

      const mDate = tz ? this.$moment.tz(date, tz) : this.$moment(date);

      return ((new Date(date)).toISOString() !== '1970-01-01T00:00:00.000Z')
        ? mDate.format(format) : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.shipment-notice__back-link {
  text-decoration: none;
  transition: color 0.3s ease-in-out 0s;

  svg {
    fill: #ad7c59;
    margin-right: 5px;
    transition: fill 0.3s ease-in-out 0s;
  }

  &:hover {
    color: var(--margaritas);

    svg {
      fill: var(--margaritas);
    }
  }
}

.shipment-notice__main {
  padding: 25px;
  background-color: #fff;

  .shipment-notice__label {
    font-size: 20px;
    font-weight: 500;
    color: var(--topaz);
  }

  .shipment-notice__value {
    font-size: 18px;
    color: var(--topaz);
    min-height: 27px;
  }
}
</style>
